import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  pdfData: null,
};

const pdfModal = createSlice({
  name: "modal",
  initialState,
  reducers: {
    storePdfData(state, action) {
      state.pdfData = action.payload.pdfData;
      state.isOpen = true;
    },
    closePdfModal(state) {
      state.isOpen = false;
      state.pdfId = null;
      state.pdfData = null;
    },
    openPdfModal(state, action) {
      state.isOpen = true;
    },
  },
});

export const { storePdfData, closePdfModal, openPdfModal } = pdfModal.actions;

export default pdfModal.reducer;
